import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {PanelService} from '../../../../commons/angular/services/panel.service';
import {ButtonSizeType} from '../../../../commons/types/button-size.type';
import {ServicePointModel} from '../../models/service-point.model';
import {ServicePointSelectListComponent} from '../service-point-select-list/service-point-select-list.component';
import {getServicePointLabel} from '../../utils/service-point-display.util';
import * as angular from 'angular';

require('./service-point-select.scss');
@Component({
  standalone: false,
  selector: 'app-service-point-select',
  templateUrl: './service-point-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicePointSelectComponent implements OnInit, OnChanges {

  @Input() selectedId: string;
  @Input() selectedPlace: string;
  @Input() ngPlaceholder: string;
  @Input() isDisabled: boolean;
  @Input() isRequired: boolean;
  @Input() event: any;
  @Input() buttonSize: ButtonSizeType = ButtonSizeType.md;
  @Output() onChange = new EventEmitter<{servicePoint: ServicePointModel | null}>();

  @ViewChild('inputRef', {static: true}) inputRef: ElementRef;

  public selectedServicePoint: ServicePointModel;
  public selectedText: string = '';

  constructor(@Inject(PanelService) private panelService: PanelService,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this._setSelectedText();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedId || changes.selectedPlace) {
      this._setSelectedText();
    }
  }

  onShowPanel(event) {
    if (!!this.isDisabled) {
      return;
    }

    const panel = this.panelService.open(ServicePointSelectListComponent,
      this.event ?? event, {
        selectedId: this.selectedId,
        ngPlaceholder: this.ngPlaceholder,
        buttonSize: this.buttonSize
      }, {
        position: {
          originX: 'center',
          originY: 'center',
          overlayX: 'start',
          overlayY: 'top'
        },
        height: 300,
        width: 300
      });

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        // Backdrop click emits null payload — keep the current selection; explicit Reset emits {servicePoint: null}.
        if (!data) {
          return;
        }
        this.selectedServicePoint = data.servicePoint ? angular.copy(data.servicePoint) : null;
        this._setSelectedText();
        this.onChange.emit({servicePoint: this.selectedServicePoint});
        this.cdr.detectChanges();
      });
    }
  }

  private _setSelectedText() {
    if (this.selectedServicePoint) {
      this.selectedText = getServicePointLabel(this.selectedServicePoint);
      return;
    }
    this.selectedText = this.selectedPlace || '';
  }
}
